import { FileItemProps, FolderItemProps } from "apis";
import useAppForm from "hooks/useAppForm";
import { FC, Fragment } from "react";
import { FormFileValuesProps } from ".";
import AppForm from "components/AppForm";

interface FormFileProps {
    onClose: () => void;
    initialValues?: FormFileValuesProps;
    onSubmit: (values: FormFileValuesProps) => void;
}
const FormFile: FC<FormFileProps> = ({ onClose, initialValues, onSubmit }) => {
    const form = useAppForm<FileItemProps>(
        (initialValues || {}) as FileItemProps,
        {
            name: { required: "Vui lòng nhập tên tài liệu!" }
        }
    );
    const { values, errors, handleChange } = form;
    return (
        <Fragment>
            <AppForm
                form={form}
                onSubmit={() => {
                    onSubmit(values);
                }}
                shadow={false}
                noStyle
            >
                <AppForm.Input
                    value={values.name}
                    onChange={name => handleChange({ name })}
                    error={errors.name}
                    required
                    placeholder="Nhập tên tài liệu..."
                />
                <AppForm.Action col={2}>
                    <button
                        type="button"
                        onClick={() => {
                            form.reset();
                            onClose();
                        }}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                    >
                        Hủy
                    </button>
                    <button
                        type="submit"
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                        Lưu
                    </button>
                </AppForm.Action>
            </AppForm>

        </Fragment>
    );
};
export default FormFile;
